import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import Leaderboard from '../components/Leaderboard';

const LeaderboardPage = () => {
  return (
    <div className="flex flex-col min-h-screen">
      <Header />
      
      <main className="flex-grow container mx-auto px-4 py-8">
        <div className="text-center mb-6">
          <h1 className="text-3xl font-bold text-emerald-600 mb-2">رېكورتلار تاختىسى</h1>
          <p className="text-gray-600 uyghur-text">ئەڭ يۇقىرى نومۇرلار</p>
        </div>
        
        <Leaderboard />
      </main>
      
      <Footer />
    </div>
  );
};

export default LeaderboardPage;